const partnerPrimary = (color?: string) => {
  if (!color) return '#332675';
  const normalized = color.trim().toLowerCase();
  if (normalized === '#fff' || normalized === '#ffffff' || normalized === 'white') {
    return '#332675';
  }
  return color;
};

export default partnerPrimary;
